import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setUser() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { user, signer, questionList, signerList } = signerState
  const selectedUser = signerList.filter((u) => u.key === signer?.key)
  if (selectedUser && selectedUser.length) {
    selectedUser[0].user = user
    yield put(setSignerList(signerList))
  }
  const selectedQuestions = signerList.filter((u) => u.key === signer?.key)
  if (selectedQuestions && selectedQuestions.length) {
    selectedQuestions[0].questionList = questionList
    yield put(setSignerList(signerList))
  }
}
export function* setUserSaga() {
  yield takeLatest([CompleteChartConstants.SET_USER], performWithMutexHOG, setUser)
}
